import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';

const usePageHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleTemplates = () => {
    navigate(`${lang}/templates-page`);
  };

  const handleEmployeesExit = () => {
    navigate(`${lang}/salary?type=employee-table&subpage=employee-deleted`);
  };

  return {
    handleToggle,
    handleBack,
    handleTemplates,
    handleClose,
    handleListKeyDown,
    handleEmployeesExit,
    open,
    anchorRef,
    navigate,
    lang,
  };
};

export default usePageHeader;
